import React, { useState } from "react";
import ProductsDashboard from "./ProductsDashboard";
import Dashboard from "./DashBoard";

const DashHeader = () => {
  const [hello, setHello] = useState(false);

  return (
    <div className="bg-white text-black py-4 px-6">
      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-2xl font-bold underline">Dashboard Header</h1>
        <div>
          <button
            onClick={() => setHello(true)}
            className={`${
              hello ? "bg-blue-500" : "bg-blue-900"
            } text-white px-4 py-2 rounded-md mr-4`}
          >
            Dashboard
          </button>
          <button
            onClick={() => setHello(false)}
            className={`${
              !hello ? "bg-blue-500" : "bg-blue-900"
            } text-white px-4 py-2 rounded-md`}
          >
            Users
          </button>
        </div>
      </div>

      <div className="container mx-auto">
        {hello ? <ProductsDashboard /> : <Dashboard />}
      </div>
    </div>
  );
};

export default DashHeader;
